/*
  Brands page: jump from the letter bar to a letter group without the group
  landing under the pinned header.

  The header is pinned by CSS, and how much of it stays on screen depends on the
  header's own settings, so the space it covers is measured at the moment of the
  jump rather than assumed. The same figure is written to a custom property so
  the browser's own anchor jumps (typing the address, back and forward) stop in
  the same place.

  Without this script the letters are ordinary in-page links and still work.
*/
(function () {
  if (window.kvBrandsPageBound) return;
  window.kvBrandsPageBound = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  /*
    How far down from the top of the screen a pinned bar reaches once it is
    pinned. A sticky element is pinned at its own top offset, so its reach is
    that offset plus its height; a fixed one is read where it stands. Anything
    hidden, narrow, or taller than half the screen (an off-canvas drawer, an
    overlay) is not a header and is skipped.
  */
  function pinnedReach() {
    var reach = 0;
    var candidates = document.querySelectorAll('[id^="shopify-section"], body > header, body > div');
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      var style = window.getComputedStyle(el);
      if (style.position !== 'sticky' && style.position !== 'fixed') continue;
      if (style.display === 'none' || style.visibility === 'hidden' || parseFloat(style.opacity) === 0) continue;

      var rect = el.getBoundingClientRect();
      if (rect.height === 0 || rect.width < window.innerWidth * 0.5 || rect.height > window.innerHeight * 0.5) continue;

      var bottom;
      if (style.position === 'fixed') {
        if (rect.top > 1) continue;
        bottom = rect.bottom;
      } else {
        var top = parseFloat(style.top);
        if (isNaN(top)) continue;
        bottom = top + rect.height;
      }
      if (bottom > reach) reach = bottom;
    }
    return Math.max(0, Math.round(reach));
  }

  function settingsOf(root) {
    var gap = parseFloat(root.getAttribute('data-jump-gap'));
    return {
      gap: isNaN(gap) ? 0 : gap,
      smooth: root.getAttribute('data-smooth') === 'true' && !(reduceMotion && reduceMotion.matches),
    };
  }

  function syncOffset(root) {
    root.style.setProperty('--kv-brands-sticky', pinnedReach() + 'px');
  }

  function jumpTo(root, group, smooth) {
    var settings = settingsOf(root);
    syncOffset(root);
    var top = group.getBoundingClientRect().top + window.pageYOffset - pinnedReach() - settings.gap;
    window.scrollTo({ top: Math.max(0, top), behavior: smooth ? 'smooth' : 'auto' });

    /* Keyboard users continue from the group they chose. */
    var heading = group.querySelector('[tabindex="-1"]');
    if (heading) {
      try {
        heading.focus({ preventScroll: true });
      } catch (error) {
        /* Older browsers without preventScroll: leave focus where it is. */
      }
    }
  }

  function bind(root) {
    if (root.hasAttribute('data-kv-brands-bound')) return;
    root.setAttribute('data-kv-brands-bound', '');
    syncOffset(root);

    root.addEventListener('click', function (event) {
      var link = event.target.closest ? event.target.closest('[data-kv-brands-jump]') : null;
      if (!link || !root.contains(link)) return;
      var id = (link.getAttribute('href') || '').slice(1);
      var group = id ? document.getElementById(id) : null;
      if (!group) return;
      event.preventDefault();
      jumpTo(root, group, settingsOf(root).smooth);
      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', '#' + id);
      }
    });

    /* An address that already names a group lands on it once the page is laid out. */
    var hash = window.location.hash ? window.location.hash.slice(1) : '';
    if (hash) {
      var target = document.getElementById(hash);
      if (target && root.contains(target)) {
        window.requestAnimationFrame(function () {
          jumpTo(root, target, false);
        });
      }
    }
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-kv-brands-page]');
    for (var i = 0; i < roots.length; i++) bind(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  window.addEventListener('resize', function () {
    var roots = document.querySelectorAll('[data-kv-brands-page]');
    for (var i = 0; i < roots.length; i++) syncOffset(roots[i]);
  });

  /* The theme editor re-renders the section rather than the page. */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
